import { render, staticRenderFns } from "./VenueCard.vue?vue&type=template&id=f335ccd0&scoped=true&"
import script from "./VenueCard.vue?vue&type=script&lang=js&"
export * from "./VenueCard.vue?vue&type=script&lang=js&"
import style0 from "./VenueCard.vue?vue&type=style&index=0&id=f335ccd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f335ccd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
